import { render, staticRenderFns } from "./PrimeCostsList.vue?vue&type=template&id=0ea45b25&"
import script from "./PrimeCostsList.vue?vue&type=script&lang=ts&"
export * from "./PrimeCostsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports